let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("inCCY")).then(() => parcelRequire('bYdjH'));